import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { PaymentButton } from './paymentButton.component';
import { selectBookingPaymentStatus } from '../../../modules/booking';
import { withKeyboardClose } from '../../../shared/components/HOC/withKeyboardClose';

const mapStateToProps = createStructuredSelector({
  paymentStatus: selectBookingPaymentStatus,
});

export const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter,
  withKeyboardClose
)(PaymentButton);
